import { Typography } from '@mui/material';

const marginText = 2;
export const TermsCopyrightPurchase = () => {
  return (
    <div className="legal-content__content">
      <Typography variant="body1" marginY={marginText}>
        The Guarantors Agency gives you the ability to perform certain
        activities and gather certain information at our site(s) on the World
        Wide Web (the “Site”). You can use the Site to gather certain
        information about our products and services, to apply online for one or
        more of our products and services, and for certain educational content
        (“Online Activities”).
      </Typography>
      <span></span>
      <Typography variant="body1" marginY={marginText}>
        When you access the Site, you’re agreeing to these terms and conditions
        of use, plus any additional terms or conditions within the Site itself
        (collectively “Terms and Conditions”). The Terms and Conditions are in
        addition to any other agreements between you and The Guarantors Agency.
        By accessing and using the Site you represent that you are over the age
        of 18.
      </Typography>
      <Typography variant="body1" marginY={marginText}>
        The Guarantors Agency reserves the right to modify or change the Terms
        and Conditions at any time without prior notice to you. Such
        modification or change shall be effective upon posting by The Guarantors
        Agency on the Site. You agree to be bound to any changes to these Terms
        and Conditions when you use the Site after any such change is posted.
      </Typography>
      <Typography
        variant="h6"
        marginY={marginText}
        fontSize={{ xs: '18px', sm: '20px' }}
      >
        Your Privacy and security on the site
      </Typography>
      <Typography variant="body1" marginY={marginText} fontWeight="500">
        Updating Your Personal Information
      </Typography>
      <Typography variant="body1" marginY={marginText}>
        You are responsible for telling The Guarantors Agency if you’ve changed
        your personal information, such as your name, telephone number, mailing
        address, e-mail address, or other personal information. You may update
        your personal information by using the Online Activities or by
        contacting The Guarantors Agency at contact@TheGuarantors.com
      </Typography>
      <Typography variant="body1" marginY={marginText} fontWeight="500">
        Spamming and Solicitation
      </Typography>
      <Typography variant="body1" marginY={marginText}>
        You may not use any information obtained from the site for spamming or
        solicitation.
      </Typography>
      <Typography
        variant="h6"
        marginY={marginText}
        fontSize={{ xs: '18px', sm: '20px' }}
      >
        Using Electronic Signatures
      </Typography>
      <Typography variant="body1" marginY={marginText} fontWeight="500">
        Online Access
      </Typography>
      <Typography variant="body1" marginY={marginText}>
        For some Online Activities, The Guarantors Agency permits “Online
        Access,” which includes the ability to use a personal computer or other
        access device equipped with an active connection to an Internet Service
        Provider to access your The Guarantors Agency accounts, policies, or
        other products and to perform certain transactions as available. You may
        register for Online Access via the Internet.
      </Typography>
      <Typography variant="body1" marginY={marginText}>
        In order to conduct some Online Activities, you agree to receive
        information applicable to your use of the Online Activities delivered to
        you electronically. These may include policy documents, quotes, billing
        statements, updates, notifications or other information that you
        request, transaction receipts, documents requiring your signature, or
        any other documents (“Communications”). Your consent does not mean that
        The Guarantors Agency must provide the Communications electronically;
        The Guarantors Agency may, at its option, provide the Communications
        through non-electronic means. As part of the Online Activities, many of
        these Communications are made available to you in non-electronic form.
        If you wish to withdraw your consent to receive information
        electronically through your use of the Online Activities, you may
        discontinue your use of the Online Access. If you have questions
        regarding Online Activities, please contact The Guarantors Agency at
        contact@TheGuarantors.com
      </Typography>
      <Typography variant="body1" marginY={marginText}>
        As part of the Online Activities, you may be given the option to sign
        certain Communications electronically by either checking the appropriate
        box or engaging in a similar online process as instructed online. You
        agree that by checking the appropriate box within or adjacent to the
        applicable Communication or engaging in a similar online electronic
        signature process, you are providing your electronic signature and agree
        to be bound by the terms and conditions in such Communication just as if
        you had signed your name to a paper document.
      </Typography>
      <Typography variant="body1" marginY={marginText}>
        Your state may require insurance documents to be displayed in a
        particular font size. To ensure that Communications are displayed at the
        correct font size for your state, please make sure that the view size
        setting for the Communications is set to 100% and your browser
        resolution is 800 x 600.
      </Typography>
      <Typography variant="body1" marginY={marginText} fontWeight="500">
        System Requirements
      </Typography>
      <Typography variant="body1" marginY={marginText}>
        To receive, access, and reply to applicable Communications you will
        need:
      </Typography>
      <ul>
        <li>
          <Typography variant="body1" marginY={marginText}>
            a personal computer or other access device with Internet access,
          </Typography>
        </li>
        <li>
          <Typography variant="body1" marginY={marginText}>
            a web browser which is capable of supporting 128-bit SSL encryption,
          </Typography>
        </li>
        <li>
          <Typography variant="body1" marginY={marginText}>
            software that lets you get and open Portable Document Format or
            “PDF” files, and
          </Typography>
        </li>
        <li>
          <Typography variant="body1" marginY={marginText}>
            the ability to download or print agreements and disclosures
          </Typography>
        </li>
      </ul>
      <Typography variant="body1" marginY={marginText} fontWeight="500">
        System Requirements to Retain Information
      </Typography>
      <Typography variant="body1" marginY={marginText}>
        To retain the Communications sent to you electronically for your
        records, your system must have the ability to download (e.g., to your
        hard disk drive or a floppy diskette), print PDF files, or print web
        pages and embedded HTML files. In some cases, you must print, complete,
        and sign Communications with a pen, and then return them to
        TheGuarantors according to the instructions on the document. To do this,
        you must have a functioning printer connected to your personal computer
        or other access device that is able to print Communications and the
        instructions on plain, white 81⁄2 x 11 inch paper.
      </Typography>
      <Typography
        variant="h6"
        marginY={marginText}
        fontSize={{ xs: '18px', sm: '20px' }}
      >
        Intellectual Property, Trademarks, and Copyrights
      </Typography>
      <Typography variant="body1" marginY={marginText} fontWeight="500">
        Intellectual Property
      </Typography>
      <Typography variant="body1" marginY={marginText}>
        Intellectual property is protected by copyrights, trademarks, service
        marks, international treaties or other proprietary rights and laws of
        the United States and other applicable countries. You agree to abide by
        all applicable proprietary rights and laws as well as any additional
        trademark or copyright notices or restrictions contained in the Terms
        and Conditions. The Terms and Conditions grant you no right, title or
        interest in The Guarantors Agency intellectual property and create no
        relationship between you and The Guarantors Agency. You may address all
        inquiries concerning use of The Guarantors Agency intellectual property
        to:&nbsp;
        <a
          className="link link--decorated"
          href="mailto:%20trademark@theguarantors.com"
        >
          <span className="link__content">trademark@TheGuarantors.com</span>
        </a>
      </Typography>
      <Typography variant="body1" marginY={marginText} fontWeight="500">
        Trademark Notice
      </Typography>
      <Typography variant="body1" marginY={marginText}>
        The trademarks, service marks, slogans, logos, trade dress and other
        identifiers (“Marks”) displayed on the Site are the property of The
        Guarantors Agency, unless otherwise disclosed. You are prohibited from
        using any Marks for any purpose including, but not limited to, use on
        other materials, in presentations, as domain names, or as metatags,
        without the written permission of The Guarantors Agency.
      </Typography>
      <Typography variant="body1" marginY={marginText} fontWeight="500">
        Copyright Notice
      </Typography>
      <Typography variant="body1" marginY={marginText}>
        © 2014-2020 The Guarantors Agency. All rights reserved.You are
        prohibited from modifying, copying, distributing, transmitting,
        displaying, publishing, selling, licensing, creating derivative works,
        or using any Content available on or through the Site for commercial or
        public purposes, without the prior written permission of The Guarantors
        Agency.
      </Typography>
      <Typography variant="body1" marginY={marginText} fontWeight="500">
        Designated Agent (Digital Millennium Copyright Act)
      </Typography>
      <Typography variant="body1" marginY={marginText}>
        If you think that a work protected by a United States copyright has been
        linked to, posted or stored on the Site without authorization, please
        contact the following agent designated to receive notification of
        claimed copyright infringement:&nbsp;
        <a
          className="link link--decorated"
          href="mailto:copyright@theguarantors.com"
        >
          <span className="link__content">copyright@TheGuarantors.com</span>
        </a>
      </Typography>
      <Typography variant="body1" marginY={marginText} fontWeight="500">
        License And Reproduction
      </Typography>
      <Typography variant="body1" marginY={marginText}>
        Original materials of The Guarantors Agency posted on the Site are
        protected by intellectual property laws. You are granted a nonexclusive,
        nontransferable, limited and revocable right to access, use, display and
        navigate the Site solely for your personal, non-public use. You are also
        granted a limited and revocable license to print copies of the Content,
        but solely for your personal, non-public use. Except as expressly
        provided above, all rights are reserved. Any commercial or public use of
        the Site or any of its Content is strictly prohibited without written
        permission from The Guarantors Agency.
      </Typography>
      <Typography variant="body1" marginY={marginText}>
        Except as expressly provided above, no portion of the Site, its Contents
        or any copyright, trademark, trade name, service mark or any other
        proprietary information of The Guarantors Agency (collectively, the
        “Intellectual Property”) displayed on the Site or on any of the Content
        may be reproduced, altered, removed, transmitted, published or
        distributed, whether electronically, mechanically, by photocopy,
        recording or otherwise, without the prior written permission of the The
        Guarantors Agency. Use of any The Guarantors Agency trademarks as
        metatags on any third-party Web site is strictly prohibited. You may not
        Co-Brand the Site or display the Site in frames (or any of the Content
        via in-line links) without prior written permission from The Guarantors
        Agency. “Co-brand” means your display of any of the Intellectual
        Property, or your taking of other means of attribution or identification
        of The Guarantors Agency in such a manner reasonably likely to give a
        third party the impression that you or such third party has the right to
        display, publish or distribute the Site or any of its Content. You agree
        to cooperate with The Guarantors Agency in causing any unauthorized
        co-branding, framing or linking to immediately cease.
      </Typography>
      <Typography variant="body1" marginY={marginText} fontWeight="500">
        Hyperlinks
      </Typography>
      <Typography variant="body1" marginY={marginText}>
        From time to time, The Guarantors Agency may authorize Linked Web Sites
        (as defined herein) to or from the Site. Linked Web Sites are controlled
        and operated by third parties and not by The Guarantors Agency. The
        Guarantors Agency makes no representations and disclaims all liability
        as to the content or material available at those locations, the accuracy
        of information, and the quality of products or services provided or
        advertised on Linked Web Sites. The fact that The Guarantors Agency
        authorizes Linked Web Sites is not an endorsement, authorization,
        express or implied sponsorship, or affiliation with respect to Linked
        Web Sites, its owners, sponsors, or providers.
      </Typography>
      <Typography variant="body1" marginY={marginText} fontWeight="500">
        Information About the Operation of the Site
      </Typography>
      <Typography variant="body1" marginY={marginText}>
        The Guarantors Agency operates the Site from its offices within the
        United States. The Guarantors Agency does not represent that Content on
        the Site is appropriate or applicable for use in any other country, and
        access from certain countries other than the United States may be
        strictly prohibited. You acknowledge and agree that you are accessing
        the Site on your own initiative, at your own risk, and are responsible
        for compliance with all local laws. These Terms and Conditions shall be
        governed by and construed in accordance with the laws of the United
        States and the State of Delaware. You consent to exclusive jurisdiction
        and venue in New York County, New York and waive the defense of forum
        non conveniens.
      </Typography>
      <Typography variant="body1" marginY={marginText} fontWeight="500">
        Submissions of Unsolicited Ideas
      </Typography>
      <Typography variant="body1" marginY={marginText}>
        The Guarantors Agency values your feedback; however, we ask that you not
        submit to us any suggestions, materials, ideas or creative concepts for
        new, modified or different products or services via the Site. The
        Guarantors Agency requests this in order to avoid confusion in the
        future regarding the origin of the concept, product or service.
      </Typography>
      <Typography variant="body1" marginY={marginText}>
        If, despite our request that you not send us any creative materials, you
        still send us creative suggestions, ideas, concepts or other information
        (collectively, the “Information”), such Information shall be deemed by
        The Guarantors Agency to be, and shall remain, the property of The
        Guarantors Agency. None of the Information shall be subject to any
        obligation of confidence on the part of The Guarantors Agency and The
        Guarantors Agency shall not be liable for any use or disclosure of any
        Information. Without limiting the foregoing, The Guarantors Agency shall
        exclusively own all rights to the Information of every kind and nature
        and shall be entitled to unrestricted use of the Information for any
        purpose whatsoever, commercial or otherwise, without compensation to the
        provider of the Information.
      </Typography>
      <Typography variant="body1" marginY={marginText} fontWeight="500">
        Visitor Submissions
      </Typography>
      <Typography variant="body1" marginY={marginText}>
        All communications initiated by you (also defined herein as a “Visitor”)
        and made to or through portions of the Site that permit uploading of
        questions, comments or other material are hereby considered “Visitor
        Submissions”.
      </Typography>
      <Typography variant="body1" marginY={marginText}>
        If you submit material intended for display where technically permitted
        within the Site, you agree to abide by the terms set forth herein.
        Visitor Submissions will not contain any content that is illegal,
        indecent, profane (either directly or indirectly through partially
        obscured words, letters, phrases, terminology or the like), threatening,
        defamatory, derogatory, counter to The Guarantors Agency Privacy Policy
        or otherwise injurious to The Guarantors Agency or third parties; and
        that will not consist of or invoke malicious software code, constitute
        commercial solicitation (except where pre-approved by The Guarantors
        Agency), consist primarily of an unsolicited electronic mass mailing, be
        political in nature, or the like. Where an email address is required to
        upload Visitor Submissions, you agree to use a valid email address and
        represent that you are the individual identified by the address. If you
        wish to submit materials to the Site, you are prohibited from
        impersonating any other individual or entity, or otherwise mislead as to
        the origination of the Visitor Submission.
      </Typography>
      <Typography variant="body1" marginY={marginText}>
        Visitor Submissions will not be accepted that infringe in any manner on
        the copyright, trademark or other intellectual property rights of any
        person or entity, or that contain privileged, confidential, proprietary
        or trade-secret information of any individual or entity, or that may
        violate the legal rights of any person or entity in any jurisdiction or
        locale. You may not submit materials that are or purport to be the
        personally identifiable information about others, such as full name,
        postal address, email address, telephone number or any other personal
        attribute which would constitute harassment or an invasion of privacy.
      </Typography>
      <Typography variant="body1" marginY={marginText}>
        Visitor Submissions become the property of The Guarantors Agency and you
        grant The Guarantors Agency a non-exclusive, royalty- free, perpetual,
        irrevocable, fully transferable, sub-licensable and assignable right to
        use, edit, modify, adapt, translate, edit, and reformat Visitor
        Submissions as necessary and for any purpose, anywhere in the world,
        including into those forms that may constitute advertising. If you
        submit a Visitor Submission, you are also hereby granting to The
        Guarantors Agency the non-exclusive right to seek enjoinment and
        possible damages from any third party who otherwise uses Visitor
        Submissions in an unauthorized way or through unauthorized reproduction
        of any Visitor Submission.
      </Typography>
      <Typography variant="body1" marginY={marginText}>
        Visitor Submissions used, displayed or propagated by The Guarantors
        Agency or others licensed by The Guarantors Agency to use Visitor
        Submissions may be attributed to you unless the visitor has expressly
        requested anonymity. The Guarantors Agency reserves the right to select
        among the Visitor Submissions for the most appropriate material to be
        used, subject to The Guarantors Agency sole discretion and judgment. The
        Guarantors Agency otherwise reserves the right to remove Visitor
        Submissions from the Site pursuant to its discretion and judgment, but
        maintains no obligation to do so.
      </Typography>
      <Typography variant="body1" marginY={marginText}>
        Visitors also hereby agree to not redistribute or reproduce elsewhere
        Visitor Submissions in any manner or in any media, including the
        re-submission or republishing of any Visitor Submission on any other
        site not affiliated with The Guarantors Agency.
      </Typography>
      <Typography
        variant="h6"
        className="legal-content-rich-text__big-margin-element"
      >
        <span
          id="limitation-of-liabilities"
          className="legal-content-rich-text__anchor"
        ></span>
        Limitation of Liabilities
      </Typography>
      <Typography variant="body1" marginY={marginText} fontWeight="500">
        The Guarantors Agency Liabilities
      </Typography>
      <Typography variant="body1" marginY={marginText}>
        IN NO EVENT WILL The Guarantors Agency ITS RESPECTIVE SERVICE PROVIDERS,
        EMPLOYEES, AGENTS, OFFICER, SHAREHOLDERS AND DIRECTORS BE LIABLE TO YOU
        FOR ANY PUNITIVE, INDIRECT, DIRECT, SPECIAL, INCIDENTAL OR CONSEQUENTIAL
        DAMAGES, INCLUDING ANY LOST PROFITS, COSTS OF PROCURING SUBSTITUTE
        SERVICE OR LOST OPPORTUNITY, EVEN IF YOU HAVE NOTIFIED The Guarantors
        Agency ABOUT THE POSSIBILITY OF SUCH DAMAGES, OR FOR ANY CLAIMS BY ANY
        THIRD PARTIES ARISING OUT OF OR IN ANY WAY RELATED TO THE ACCESS, USE OR
        CONTENT OF THE SITE OR A LINKED WEB SITE WHETHER SUCH CLAIMS ARE BROUGHT
        UNDER ANY THEORY OF LAW OR EQUITY.
      </Typography>
      <Typography variant="body1" marginY={marginText}>
        THIS LIMITATION ON LIABILITY INCLUDES, BUT IS NOT LIMITED TO,
        TRANSMISSION OF VIRUSES THAT INFECTS A USER’S EQUIPMENT, MECHANIC OR
        ELECTRONIC EQUIPMENT FAILURE, FAILURE OF COMMUNICATION LINES, TELEPHONE
        OR OTHER INTERCONNECTS, UNAUTHORIZED ACCESS, THEFT, OPERATIONAL ERRORS,
        STRIKES OR OTHER LABOR PROBLEMS, OR ANY FORCE MAJEURE.
      </Typography>
      <Typography variant="body1" marginY={marginText} fontWeight="500">
        Your Liabilities
      </Typography>
      <Typography variant="body1" marginY={marginText}>
        The Guarantors Agency has the right to deny you access and use of the
        Site and its Content (as defined herein) if you violate (as The
        Guarantors Agency may determine in their sole and absolute discretion)
        any provision of the Terms and Conditions. The Guarantors Agency
        reserves the right to seek all other remedies available at law and in
        equity. You agree, at your own expense, to defend, indemnify and hold
        The Guarantors Agency harmless from any claim or demand, including
        reasonable attorneys’ fees, made by a third party in connection with or
        arising out of your access to, or use of, the Site or any of its Content
        in a manner other than as expressly authorized by the Terms and
        Conditions, your breach of the Terms and Conditions or your violation of
        applicable laws or any rights of any third party.
      </Typography>
      <Typography variant="body1" marginY={marginText}>
        Disclaimer of Warranties
      </Typography>
      <Typography variant="body1" marginY={marginText}>
        ALL INFORMATION AND OTHER MATERIALS PRESENT ON THE SITE (“CONTENT”),
        INCLUDING, WITHOUT LIMITATION, PRODUCTS AND SERVICES ARE PROVIDED “AS
        IS,” WITHOUT ANY WARRANTIES ABOUT THE CONTENT’S NATURE OR ACCURACY
        (EITHER WHEN POSTED OR AS A RESULT OF THE PASSAGE OF TIME) AND WITHOUT
        ANY REPRESENTATIONS OR GUARANTEES.
      </Typography>
      <Typography variant="body1" marginY={marginText}>
        WITHOUT LIMITING THE ABOVE, The Guarantors Agency DISCLAIMS ALL
        WARRANTIES, EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO WARRANTIES
        OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE,
        NON-INFRINGEMENT, SECURITY OR ACCURACY WITH REGARD TO ANY WEB SITE OWNED
        BY A THIRD PARTY TO WHICH OR FROM WHICH THE SITE IS LINKED (“LINKED WEB
        SITE”). The Guarantors Agency DOES NOT ENDORSE AND IS NOT RESPONSIBLE
        FOR THE CAPABILITIES OR RELIABILITY OF ANY PRODUCT OR SERVICE OBTAINED
        FROM A LINKED WEB SITE.
      </Typography>
      <Typography variant="body1" marginY={marginText}>
        THE INFORMATION, PRODUCTS, SOFTWARE OR SERVICE DESCRIPTIONS PUBLISHED ON
        THE SITE OR A LINKED WEB SITE MAY INCLUDE INACCURACIES OR TYPOGRAPHICAL
        ERRORS. THE COMPANY DISCLAIMS LIABILITY FOR SUCH ERRORS AND DOES NOT
        WARRANT OR REPRESENT THAT THE CONTENT ON THE SITE OR A LINKED WEB SITE
        IS UPDATED OR COMPLETE. The Guarantors Agency HAS NO OBLIGATION TO
        UPDATE ANY CONTENT ON THE SITE AND MAY CHANGE OR IMPROVE THE SITE AT ANY
        TIME WITHOUT NOTICE.
      </Typography>
      <Typography variant="body1" marginY={marginText}>
        The Guarantors Agency does not endorse and is not responsible for the
        accuracy or reliability of any opinion, advice or statement made through
        the Site by any party other than The Guarantors Agency.The Guarantors
        Agency make no representations, warranties or guarantees that the Site
        will be accessible continuously and without interruption, or error free.
      </Typography>
      <Typography variant="body1" marginY={marginText} fontWeight="500" >
        Products Mentioned In This Site
      </Typography>
      <Typography variant="body1" marginY={marginText}>
        No security or insurance product is offered or will be sold in any
        jurisdiction in which such offer or solicitation would be unlawful under
        the laws of the jurisdiction. Some products, product features, or
        underlying investment options may not be available in all states.
      </Typography>
      <Typography variant="body1" marginY={marginText} fontWeight="500">
        Important Disclosures About The Guarantors Agency Products
      </Typography>
      <Typography variant="body1" marginY={marginText}>
        Product, coverage, discounts, insurance terms, definitions, and other
        descriptions are intended for informational purposes only and do not in
        any way replace or modify the definitions and information contained in
        your individual insurance contracts, policies, and/or declaration pages
        from The Guarantors Agency- affiliated underwriting companies, which are
        controlling. Such products, coverages, terms, and discounts may vary by
        state and exclusions may apply.
      </Typography>
      <Typography variant="body1" marginY={marginText}>
        Products underwritten by Our Insurance Partner. Products and discounts
        are not offered by all companies nor are all products and discounts
        available to all persons in all states, and at all times are subject to
        underwriting guidelines, review, and approval.
      </Typography>
      <Typography variant="body1" marginY={marginText} fontWeight="500">
        No Offer
      </Typography>
      <Typography variant="body1" marginY={marginText}>
        Information in the Site is not a solicitation, offer, recommendation,
        invitation or inducement to buy or sell any investment or to enter into
        or conclude any transaction.
      </Typography>
      <Typography variant="body1" marginY={marginText} fontWeight="500">
        Entire Agreement
      </Typography>
      <Typography variant="body1" marginY={marginText}>
        Except to the extent otherwise set forth in the Terms and Conditions,
        these Terms and Conditions set forth the entire understanding between
        The Guarantors Agency and you with respect to your access to, and use
        of, the Site and its Content and supersedes all prior or contemporaneous
        understandings regarding access and use.
      </Typography>
      <Typography variant="body1" marginY={marginText} fontWeight="500">
        Severability
      </Typography>
      <Typography variant="body1" marginY={marginText}>
        If any portion of these Terms and Conditions is found to be
        unenforceable, the remaining sections of the Terms and Conditions will
        remain in effect.
      </Typography>
      <Typography variant="body1" marginY={marginText} fontWeight="500">
        Waiver
      </Typography>
      <Typography variant="body1" marginY={marginText}>
        Failure by The Guarantors Agency, in any instance, to exercise any of
        its rights under the Terms and Conditions will not constitute waiver of
        such right or any other rights under the Terms and Conditions.
      </Typography>
    </div>
  );
};
